import React from 'react';
import PropTypes from 'prop-types';
import { getCountryCode, formatText } from '@/helpers/utils';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useSelectedProductFromUserWallet } from '@/hooks/memberHooks';

const LoungeAccessProductDescription = ({ locale, product }) => {
  const { selectCard, productDisplayNames } = useCommonContent();
  const productTitle = productDisplayNames[product]?.cardCallOutDisplayName;
  const countryCode = getCountryCode(product, locale);
  const urlSpecifiedProductFromUsersWallet =
    useSelectedProductFromUserWallet(product);
  const cardLastDigits = urlSpecifiedProductFromUsersWallet
    ? urlSpecifiedProductFromUsersWallet.displayAccountNumber
    : '';
  const message = cardLastDigits // Logged in text shows this card's last 5 digits, so we need to fallback to logged out text if we don't have that.
    ? selectCard?.message_loggedIn
    : selectCard?.message;

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: formatText(message, {
          productTitle,
          countryCode,
          lastDigits: cardLastDigits,
        }),
      }}
    />
  );
};

LoungeAccessProductDescription.propTypes = {
  locale: PropTypes.string.isRequired,
  product: PropTypes.string.isRequired,
};

export default LoungeAccessProductDescription;
